import React from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {EdgesLineControl} from "./EdgesLineControl";

export function EdgesControl() {
    const data = useCountertops();

    return (
        <>
            <p className={"box-header"}>
                Edge*
            </p>
            {data.selectedGroups.length === 0 ? <p>Add shape and material to see Available Edge options</p> :
            data.selectedGroups.map(group => <EdgesLineControl key={group.prodQteGrpID} group={group}/>)}
        </>
    );
}